















































































































































import Vue from 'vue'
import { number } from '@/utils/validators'
import {
  consultRemittancePrice,
  getTariffs,
} from '@/api/Remittances/remittances.api'
import { Params, PaymentMethods, VueForm } from '@/utils/interfaces'
import {
  DeliveryCurrenciesEnum,
  Tariff,
} from '@/utils/interfaces/remittance.interface'
import { getCountries, getRegions, getSubregions } from '@/api/Address/address'
import Autocomplete from '~/components/Autocomplete.vue'
import { ConsultPriceResponse } from '~/api/Remittances/remittances.dto'
import ConfirmDialog from '~/components/ConfirmDialog.vue'

export default Vue.extend({
  components: {
    Autocomplete,
    ConfirmDialog,
  },
  data() {
    return {
      rules: {
        required: (v: string) => !!v || this.$t('validation.field-required'),
        number: (v: string) =>
          number(v.toString()) || this.$t('validation.must-be-a-number'),
      },
      crud: {
        subregion: '',
        delivery_currency: DeliveryCurrenciesEnum.MLC,
        amount: '',
        description: '',
        tariff: '',
        distribute_with_network: false,
        payment_method: PaymentMethods.Zelle,
        address: {
          country: null,
          country_name: 'Cuba',
          region: null,
          region_name: '',
          subregion: null,
          subregion_name: '',
        },
      },
      priceTags: {
        agency_cost: 'agency_cost',
        'shipping-charge': 'cost',
        'total-to-pay': 'price_to_pay',
        'amount-to-deliver': 'delivery_amount',
      },
      prices: null as null | ConsultPriceResponse,
      min: 0,
      max: 1,
      deliveryCurrencies: Object.values(DeliveryCurrenciesEnum),
      tariffs: [] as Tariff[],
      dialog: false,
    }
  },
  computed: {
    loading: {
      set(value: boolean): void {
        this.$store.commit('loading', value)
      },
      get(): boolean {
        return this.$store.getters.loading
      },
    },
    computedTariffs(): Tariff[] {
      return !this.crud.amount
        ? this.tariffs.filter(
            tariff => tariff.delivery_currency === this.crud.delivery_currency,
          )
        : this.tariffs.filter(
            tariff =>
              Number(tariff.min_amount) <= Number(this.crud.amount) &&
              Number(tariff.max_amount) >= Number(this.crud.amount) &&
              tariff.delivery_currency === this.crud.delivery_currency,
          )
    },
  },
  methods: {
    getCountries,
    getRegions(params?: Params) {
      return getRegions({ ...params, country: this.crud.address.country })
    },
    getSubregions(params?: Params) {
      return getSubregions({ ...params, region: this.crud.address.region })
    },
    async onConsult() {
      const form = this.$refs.form as VueForm

      if (!form.validate()) return

      this.loading = true

      try {
        const response = await consultRemittancePrice({
          amount: this.crud.amount,
          delivery_currency: this.crud.delivery_currency,
          tariff: this.crud.tariff,
          distribute_with_network: this.crud.distribute_with_network,
          subregion: this.crud.address.subregion ?? 0,
        })

        this.prices = response.data
      } finally {
        this.loading = false
      }
    },
  },
  watch: {
    'crud.address.subregion': {
      handler() {
        getTariffs({
          region: this.crud.address.region,
          type: 'CLIENT',
          limit: 20,
          is_active: true,
        }).then(response => {
          this.tariffs = response.data.results
        })
      },
    },
  },
})
